import React, { useMemo } from 'react';
import c from 'classnames';
import type Immutable from 'immutable';

import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';
import Slider from '../Slider';
import RenderItem from './Item';

import './style.scss';

const DEFAULT_SLIDER_PROPS = {
  infinite: true,
  variableWidth: false,
};

export interface ImageSliderProps {
  images: Immutable.List<MediaReferenceField<'image'>>;
  isFullScreen?: boolean;
  sliderProps?: Record<string, any>;
  className?: string;
  lazyload?: boolean;
}

const ImageSlider: React.FC<ImageSliderProps> = (props) => {
  const {
    images,
    isFullScreen = false,
    sliderProps: customSliderProps,
    className,
    lazyload = true,
  } = props;

  const classNames = c('ImageSlider', className, {
    'ImageSlider--fullScreen': isFullScreen,
  });

  const sliderProps = useMemo(() => ({
    ...DEFAULT_SLIDER_PROPS,
    ...(customSliderProps && Object.keys(customSliderProps).length > 0 ? customSliderProps : {}),
  }), [customSliderProps]);

  return (
    <Slider
      className={classNames}
      items={images}
      sliderProps={sliderProps}
      RenderItem={RenderItem}
      renderItemProps={{
        isFullScreen,
      }}
      lazyload={lazyload}
    />
  );
};

export default ImageSlider;
